import { Typography } from "@material-ui/core";
import React from "react";
import styled from "styled-components";
import { observer } from "mobx-react";
import { Paper } from "../../../../../common/components/libs";
import {Trans, useTranslation} from "react-i18next";


const Wrapper = styled(Paper)`
  padding: ${
    props => {
        return props.theme.spacing(6)
    }}px;

  ${props => props.theme.breakpoints.up("md")} {
    padding: ${props => props.theme.spacing(10)}px;
  }
`;


const NoTopItemsReport = () => {
    const {i18n, t} = useTranslation(["general", "stats"]);
    const locale = i18n.language;

    return <div style={{ maxWidth: 500 }}>
        <Wrapper>
            <Typography component="h1" variant="h4" align="center" gutterBottom>
                {t("stats:noOrders")}
            </Typography>
            <Typography component="h4" variant="body2" align="center" gutterBottom>
                {t("stats:noOrders")}
            </Typography>
        </Wrapper>
    </div>
};


export default observer(NoTopItemsReport)
